/**
 * Amateur custom header (option_6): logo scroll effect.
 *
 * Preferred: CSS scroll(root) animation (compositor-smooth). See am-header-custom.css.
 * Fallback: --logo-scroll-offset via rAF when scroll(root) unsupported.
 */
(function () {
  const SCROLL_RANGE = 400;
  let menuCurrentlyOpen = false;
  let cssScrollTimeline = false;
  let cachedMaxOffset = 0;
  let cachedNavTeaserMaxOffset = 0;
  let suppressNavTeaserUntilTop = false;
  let collectionHeaderSuppressedUntilTop = false;
  let lastScrollY = 0;
  let stickyShowAddedForMenuOpen = false;
  let pendingLayoutUnfreezeHeader = null;
  let pendingLogoUnfreezeTimer = null;
  let frozenMenuScrollY = 0;
  let desktopMenuScrollLockY = 0;
  let desktopMenuScrollLockActive = false;
  let mobileMenuBodyPinned = false;
  let menuOpenFlowCompensationActive = false;
  var MENU_CLOSE_MS = 320;

  /*
   * Body is the effective scroll container on this theme (overflow-y: auto on body,
   * html often clip/hidden). Read/write all roots so lock survives engine differences.
   */
  function getScrollY() {
    return (
      window.scrollY ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0
    );
  }

  function setScrollY(y) {
    var top = Math.max(0, y | 0);
    window.scrollTo(0, top);
    document.documentElement.scrollTop = top;
    document.body.scrollTop = top;
    lastScrollY = top;
  }

  function getPageHeaderSection() {
    return document.querySelector(
      '.shopify-section.page-header, div.page-header.shopify-section',
    );
  }

  function measurePageHeaderFlowHeight() {
    var section = getPageHeaderSection();
    if (section && !document.body.classList.contains('menu-open')) {
      return section.offsetHeight || 0;
    }
    /* Menu-open: section is fixed and may include the drawer — use header bar only. */
    var header = document.querySelector('#header.wt-header--amateur-custom');
    if (header) {
      return header.offsetHeight || 0;
    }
    var cssHeight = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue('--header-height'),
    );
    return cssHeight > 0 ? cssHeight : 0;
  }

  function applyMenuOpenFlowCompensation(height) {
    var main = document.getElementById('root');
    if (!main || height <= 0) return;
    menuOpenFlowCompensationActive = true;
    main.style.setProperty('margin-top', height + 'px', 'important');
    document.documentElement.style.setProperty(
      '--am-menu-header-flow-offset',
      height + 'px',
    );
  }

  function clearMenuOpenFlowCompensation() {
    if (!menuOpenFlowCompensationActive) return;
    menuOpenFlowCompensationActive = false;
    var main = document.getElementById('root');
    if (main) main.style.removeProperty('margin-top');
    document.documentElement.style.removeProperty('--am-menu-header-flow-offset');
  }

  function isDesktopMenuClosePending() {
    return (
      !!pendingLayoutUnfreezeHeader ||
      document.body.classList.contains('am-header-menu-closing')
    );
  }

  function syncBodyScrollbarPadding(snapshot) {
    const scrollbarWidth = snapshot
      ? snapshot.scrollbarWidth
      : Math.max(0, window.innerWidth - document.documentElement.clientWidth);
    const viewportDelta = window.innerWidth - document.documentElement.clientWidth;

    if (scrollbarWidth > 0 && viewportDelta === 0) {
      document.body.style.setProperty('padding-right', scrollbarWidth + 'px', 'important');
      document.documentElement.style.setProperty(
        '--am-scrollbar-compensation',
        scrollbarWidth + 'px',
      );
    } else if (viewportDelta > 0) {
      document.body.style.removeProperty('padding-right');
      document.documentElement.style.removeProperty('--am-scrollbar-compensation');
    }
  }

  function restoreFrozenScroll() {
    if (!desktopMenuScrollLockActive) return;
    const lockY = frozenMenuScrollY || desktopMenuScrollLockY || 0;
    if (getScrollY() !== lockY) {
      setScrollY(lockY);
    }
  }

  let menuScrollClampRafId = 0;

  function startDesktopMenuScrollClamp() {
    if (menuScrollClampRafId) return;
    function clamp() {
      if (!desktopMenuScrollLockActive) {
        menuScrollClampRafId = 0;
        return;
      }
      restoreFrozenScroll();
      menuScrollClampRafId = requestAnimationFrame(clamp);
    }
    menuScrollClampRafId = requestAnimationFrame(clamp);
  }

  function stopDesktopMenuScrollClamp() {
    if (!menuScrollClampRafId) return;
    cancelAnimationFrame(menuScrollClampRafId);
    menuScrollClampRafId = 0;
  }

  function pinMobileMenuBody(scrollY) {
    if (mobileMenuBodyPinned) return;
    mobileMenuBodyPinned = true;
    /* Avoid body position:fixed + top:-scrollY — iOS Safari then parks the
       fixed drawer off-screen (gray overlay only). Overflow + touch lock is enough. */
    frozenMenuScrollY = scrollY || frozenMenuScrollY || 0;
    document.documentElement.style.setProperty('overflow', 'hidden', 'important');
    document.documentElement.style.setProperty('overscroll-behavior', 'none', 'important');
    document.body.style.setProperty('overflow', 'hidden', 'important');
    document.body.style.setProperty('overscroll-behavior', 'none', 'important');
    document.body.style.setProperty('touch-action', 'none', 'important');
  }

  function unpinMobileMenuBody() {
    if (!mobileMenuBodyPinned) return;
    var y = frozenMenuScrollY || desktopMenuScrollLockY || 0;
    mobileMenuBodyPinned = false;
    document.documentElement.style.removeProperty('overflow');
    document.documentElement.style.removeProperty('overscroll-behavior');
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('overscroll-behavior');
    document.body.style.removeProperty('touch-action');
    document.body.style.removeProperty('position');
    document.body.style.removeProperty('top');
    document.body.style.removeProperty('left');
    document.body.style.removeProperty('right');
    document.body.style.removeProperty('width');
    setScrollY(y);
  }

  function setDesktopMenuScrollLock(active, scrollY) {
    /* Desktop: clamp + preventDefault (keeps overflow visible to avoid scrollbar gutter).
       Mobile: html/body overflow hidden + touchmove preventDefault.
       Avoid body position:fixed — iOS Safari then parks fixed drawer off-screen. */
    var isMobileMenu = !window.matchMedia('(min-width: 1200px)').matches;
    desktopMenuScrollLockActive = active;
    if (active) {
      desktopMenuScrollLockY = scrollY;
      if (!frozenMenuScrollY) {
        frozenMenuScrollY = scrollY;
      }
      if (isMobileMenu) {
        pinMobileMenuBody(frozenMenuScrollY || scrollY);
        stopDesktopMenuScrollClamp();
      } else {
        unpinMobileMenuBody();
        restoreFrozenScroll();
        startDesktopMenuScrollClamp();
      }
      return;
    }

    desktopMenuScrollLockY = 0;
    stopDesktopMenuScrollClamp();
    unpinMobileMenuBody();
  }

  function onDesktopMenuScrollLock() {
    if (!desktopMenuScrollLockActive) return;
    restoreFrozenScroll();
  }

  function onDesktopMenuWheelLock(e) {
    if (!desktopMenuScrollLockActive) return;

    const drawer = document.querySelector('#wt-drawer-nav');
    if (drawer && drawer.contains(e.target)) return;

    e.preventDefault();
  }

  function onDesktopMenuTouchMoveLock(e) {
    if (!desktopMenuScrollLockActive) return;

    const drawer = document.querySelector('#wt-drawer-nav');
    if (drawer && drawer.contains(e.target)) return;

    e.preventDefault();
  }

  function onDesktopMenuKeydownLock(e) {
    if (!desktopMenuScrollLockActive) return;

    if (
      e.key === 'ArrowUp' ||
      e.key === 'ArrowDown' ||
      e.key === 'PageUp' ||
      e.key === 'PageDown' ||
      e.key === 'Home' ||
      e.key === 'End' ||
      e.key === ' ' ||
      e.key === 'Spacebar'
    ) {
      e.preventDefault();
    }
  }

  function hideMenuOverlayImmediate() {
    const overlay = document.querySelector('.menu-drawer-overlay');
    if (!overlay) return;
    overlay.style.setProperty('opacity', '0', 'important');
    overlay.style.setProperty('transform', 'scale(0)', 'important');
    overlay.style.setProperty('transition', 'none', 'important');
    overlay.style.setProperty('pointer-events', 'none', 'important');
  }

  function resetMenuOverlayStyles() {
    const overlay = document.querySelector('.menu-drawer-overlay');
    if (!overlay) return;
    overlay.style.removeProperty('opacity');
    overlay.style.removeProperty('transform');
    overlay.style.removeProperty('transition');
    overlay.style.removeProperty('pointer-events');
  }

  function isCollectionMobile() {
    return (
      document.body.classList.contains('template-collection') &&
      window.matchMedia('(max-width: 899px)').matches
    );
  }

  function getLogoScrollHeight(header) {
    const logoLink = header.querySelector('.wt-header__logo__link.am-kits-logos--paired');
    if (logoLink && logoLink.classList.contains('am-kits-logos--ready')) {
      return logoLink.offsetHeight || 0;
    }

    const logo = header.querySelector('.wt-header__logo');
    return logo ? logo.offsetHeight : 0;
  }

  function getMaxOffset() {
    const header = document.querySelector('.wt-header--amateur-custom');
    if (!header) return 0;
    const logoHeight = getLogoScrollHeight(header);
    if (!logoHeight) return 0;

    const isDesktop = window.innerWidth > 768;
    const restTopPadding = isDesktop ? 20 : 16;
    const visiblePx = isDesktop ? 37 : 16;
    return Math.max(0, restTopPadding + logoHeight - visiblePx);
  }

  function getNavTeaserMaxOffset(header) {
    const navTeaser = header.querySelector('.wt-header__nav-teaser');
    const body = header.querySelector('.wt-header__body');
    if (!navTeaser || !body) return 0;

    const paddingTop = parseFloat(getComputedStyle(body).paddingTop) || 0;
    let contentHeight = 0;

    Array.from(navTeaser.children).forEach(function (child) {
      contentHeight = Math.max(contentHeight, child.offsetTop + child.offsetHeight);
    });

    if (!contentHeight) {
      contentHeight = navTeaser.scrollHeight || navTeaser.getBoundingClientRect().height;
    }

    return Math.ceil(paddingTop + contentHeight);
  }

  function refreshMaxOffset() {
    const header = document.querySelector('.wt-header--amateur-custom');
    if (!header) return;

    cachedMaxOffset = getMaxOffset();
    cachedNavTeaserMaxOffset = getNavTeaserMaxOffset(header);
    header.style.setProperty('--logo-scroll-max', cachedMaxOffset + 'px');
    header.style.setProperty('--nav-teaser-scroll-max', cachedNavTeaserMaxOffset + 'px');
    header.style.setProperty('--logo-scroll-range', SCROLL_RANGE + 'px');
  }

  function setLogoScrollMode() {
    const header = document.querySelector('.wt-header--amateur-custom');
    if (!header) return;

    refreshMaxOffset();

    cssScrollTimeline =
      typeof CSS !== 'undefined' &&
      CSS.supports('animation-timeline', 'scroll(root)');

    header.classList.toggle('am-logo-scroll--css', cssScrollTimeline);
    // Keep compact ("up") logo until the menu finish-close unfreeze runs.
    header.classList.toggle(
      'am-logo-scroll--menu-open',
      menuCurrentlyOpen || isDesktopMenuClosePending(),
    );
    header.classList.toggle('am-logo-scroll--footer-reveal', isFooterRevealActive());

    if (isFooterRevealActive()) {
      header.style.setProperty('--logo-scroll-offset', '-' + cachedMaxOffset + 'px');
      header.style.removeProperty('--nav-teaser-scroll-offset');
      return;
    }

    if (!cssScrollTimeline) {
      if (!isDesktopMenuClosePending()) {
        updateLogoScrollFallback();
      }
    } else {
      header.style.removeProperty('--logo-scroll-offset');
      header.style.removeProperty('--nav-teaser-scroll-offset');
    }
  }

  function isDesktopMegaNav() {
    return window.matchMedia('(min-width: 1200px)').matches;
  }

  function isBrandsDesktop() {
    return (
      isDesktopMegaNav() &&
      (document.body.classList.contains('am-brands-page') ||
        document.body.classList.contains('template-page-brands'))
    );
  }

  function isProductCompactLogoViewport() {
    return (
      document.body.classList.contains('template-product') &&
      window.matchMedia('(min-width: 900px)').matches
    );
  }

  function getLogoScrollProgress() {
    if (isBrandsDesktop()) return 1;
    if (isProductCompactLogoViewport()) return 1;
    const scrollY = window.scrollY || document.documentElement.scrollTop;
    return Math.min(1, scrollY / SCROLL_RANGE);
  }

  function isFooterRevealActive() {
    return document.body.classList.contains('am-header-footer-reveal');
  }

  function isKitsMobileFooterReveal() {
    return (
      document.body.classList.contains('am-amateur-kits-page') &&
      window.matchMedia('(max-width: 899px)').matches
    );
  }

  function applyNavTeaserSuppressionState() {
    if (!isKitsMobileFooterReveal()) return;
    const header = document.querySelector('.wt-header--amateur-custom');
    if (!header || menuCurrentlyOpen) return;
    const navTeaser = header.querySelector('.wt-header__nav-teaser');
    if (!navTeaser) return;

    if (isFooterRevealActive() && !suppressNavTeaserUntilTop) return;

    const scrollY = window.scrollY || document.documentElement.scrollTop || 0;
    if (!suppressNavTeaserUntilTop) {
      header.classList.remove('am-nav-teaser--suppressed-until-top');
      navTeaser.style.removeProperty('animation');
      navTeaser.style.removeProperty('animation-timeline');
      navTeaser.style.removeProperty('transform');
      navTeaser.style.removeProperty('visibility');
      navTeaser.style.removeProperty('pointer-events');
      return;
    }

    if (scrollY <= 1) {
      suppressNavTeaserUntilTop = false;
      header.classList.remove('am-nav-teaser--suppressed-until-top');
      navTeaser.style.removeProperty('animation');
      navTeaser.style.removeProperty('animation-timeline');
      navTeaser.style.removeProperty('transform');
      navTeaser.style.removeProperty('visibility');
      navTeaser.style.removeProperty('pointer-events');
      if (!cssScrollTimeline) {
        updateLogoScrollFallback();
      }
      return;
    }

    header.classList.add('am-nav-teaser--suppressed-until-top');
    navTeaser.style.setProperty('animation', 'none', 'important');
    navTeaser.style.setProperty('animation-timeline', 'auto', 'important');
    navTeaser.style.setProperty(
      'transform',
      'translate3d(0, calc(-1 * ' + cachedNavTeaserMaxOffset + 'px), 0)',
      'important',
    );
    navTeaser.style.setProperty('visibility', 'hidden', 'important');
    navTeaser.style.setProperty('pointer-events', 'none', 'important');
  }

  function applyCollectionHeaderSuppressionState() {
    if (!isCollectionMobile()) return;

    /* Keep collection mobile header sticky/visible like desktop — do not hide after footer reveal. */
    collectionHeaderSuppressedUntilTop = false;
    document.body.classList.remove('am-collection-header-suppressed-until-top');
  }

  function onFooterRevealChange(isActive) {
    const header = document.querySelector('.wt-header--amateur-custom');
    if (!header) return;

    const wasFooterReveal =
      header.classList.contains('am-logo-scroll--footer-reveal') ||
      document.body.classList.contains('am-header-footer-reveal');
    header.classList.toggle('am-logo-scroll--footer-reveal', isActive);

    if (isActive) {
      suppressNavTeaserUntilTop = false;
      collectionHeaderSuppressedUntilTop = false;
      document.body.classList.remove('am-collection-header-suppressed-until-top');
      header.classList.remove('am-nav-teaser--suppressed-until-top');
      const navTeaser = header.querySelector('.wt-header__nav-teaser');
      if (navTeaser) {
        navTeaser.style.removeProperty('animation');
        navTeaser.style.removeProperty('animation-timeline');
        navTeaser.style.removeProperty('transform');
        navTeaser.style.removeProperty('visibility');
        navTeaser.style.removeProperty('pointer-events');
      }
      header.style.setProperty('--logo-scroll-offset', '-' + cachedMaxOffset + 'px');
      header.style.removeProperty('--nav-teaser-scroll-offset');
    } else {
      const kitLogo = header.querySelector('.am-kits-kit-logo');
      if (kitLogo) {
        kitLogo.style.removeProperty('filter');
        kitLogo.style.removeProperty('-webkit-filter');
      }
      if (wasFooterReveal && isKitsMobileFooterReveal()) {
        suppressNavTeaserUntilTop = true;
        applyNavTeaserSuppressionState();
      }
      if (!cssScrollTimeline && !menuCurrentlyOpen) {
        updateLogoScrollFallback();
      }
    }
    applyCollectionHeaderSuppressionState();
  }

  function shouldScrollNavTeaserAway() {
    return (
      document.body.classList.contains('am-amateur-kits-page') &&
      !!document.querySelector('.am-collection-bar')
    );
  }

  function updateLogoScrollFallback() {
    if (cssScrollTimeline || menuCurrentlyOpen || isFooterRevealActive()) {
      return;
    }
    const header = document.querySelector('.wt-header--amateur-custom');
    if (!header) return;
    const progress = getLogoScrollProgress();
    const offsetPx = cachedMaxOffset * progress;
    header.style.setProperty('--logo-scroll-offset', '-' + offsetPx + 'px');

    if (!shouldScrollNavTeaserAway()) {
      header.style.removeProperty('--nav-teaser-scroll-offset');
      return;
    }

    if (suppressNavTeaserUntilTop && isKitsMobileFooterReveal()) {
      const scrollY = window.scrollY || document.documentElement.scrollTop || 0;
      if (scrollY > 1) {
        header.classList.add('am-nav-teaser--suppressed-until-top');
        header.style.setProperty('--nav-teaser-scroll-offset', '-' + cachedNavTeaserMaxOffset + 'px');
        return;
      }
      suppressNavTeaserUntilTop = false;
      header.classList.remove('am-nav-teaser--suppressed-until-top');
    }

    const navTeaserOffsetPx = cachedNavTeaserMaxOffset * progress;
    header.style.setProperty('--nav-teaser-scroll-offset', '-' + navTeaserOffsetPx + 'px');
  }

  let ticking = false;
  function onScrollFallback() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      const scrollY = window.scrollY || document.documentElement.scrollTop || 0;
      const scrollingUp = scrollY < lastScrollY - 0.5;
      const scrollingDown = scrollY > lastScrollY + 0.5;

      if (isKitsMobileFooterReveal()) {
        if (scrollingUp && isFooterRevealActive()) {
          suppressNavTeaserUntilTop = true;
        } else if (scrollingDown && isFooterRevealActive()) {
          suppressNavTeaserUntilTop = false;
        }
      }

      lastScrollY = scrollY;
      applyNavTeaserSuppressionState();
      applyCollectionHeaderSuppressionState();
      if (!cssScrollTimeline) {
        updateLogoScrollFallback();
      }
      ticking = false;
    });
  }

  let pendingMenuOpenSnapshot = null;
  let pendingMenuOpenFlowHeight = 0;

  function getVisibleLogoImg(header) {
    return (
      header.querySelector('.wt-header__logo__img--responsive:not(.wt-header__logo__img--transparent)') ||
      header.querySelector('.wt-header__logo__img:not(.wt-header__logo__img--transparent)')
    );
  }

  function captureHeaderScrollSnapshot(header) {
    const rightSide = header.querySelector('.wt-header__right-side');
    const navTeaser = header.querySelector('.wt-header__nav-teaser');
    const headerBody = header.querySelector('.wt-header__body');
    const logoImg = getVisibleLogoImg(header);
    const headerRect = header.getBoundingClientRect();
    const rightSideRect = rightSide ? rightSide.getBoundingClientRect() : null;
    const bodyRect = headerBody ? headerBody.getBoundingClientRect() : null;
    const logoRect = logoImg ? logoImg.getBoundingClientRect() : null;
    const snapshot = {
      headerWidth: headerRect.width,
      headerLeft: headerRect.left,
      bodyWidth: bodyRect ? bodyRect.width : 0,
      rightSideWidth: rightSideRect ? rightSideRect.width : 0,
      logoWidth: logoRect ? logoRect.width : 0,
      logoHeight: logoRect ? logoRect.height : 0,
      scrollbarWidth: Math.max(0, window.innerWidth - document.documentElement.clientWidth),
      rightTransform: null,
      navTransform: null,
      navVisibility: null,
      navPointerEvents: null,
    };

    if (rightSide) {
      snapshot.rightTransform = getComputedStyle(rightSide).transform;
    }
    if (navTeaser) {
      const navStyle = getComputedStyle(navTeaser);
      snapshot.navTransform = navStyle.transform;
      snapshot.navVisibility = navStyle.visibility;
      snapshot.navPointerEvents = navStyle.pointerEvents;
    }

    return snapshot;
  }

  function primeMenuOpenSnapshot() {
    if (!window.matchMedia('(min-width: 1200px)').matches) return;
    const header = document.querySelector('.wt-header--amateur-custom');
    if (!header) return;
    pendingMenuOpenFlowHeight = measurePageHeaderFlowHeight();
    const scrollY = getScrollY();
    if (scrollY <= 0) return;
    frozenMenuScrollY = scrollY;
    pendingMenuOpenSnapshot = captureHeaderScrollSnapshot(header);
  }

  function applyDesktopMenuOpenLayoutLock(scrollY) {
    var flowHeight = pendingMenuOpenFlowHeight || measurePageHeaderFlowHeight();
    pendingMenuOpenFlowHeight = 0;
    if (flowHeight > 0) {
      applyMenuOpenFlowCompensation(flowHeight);
    }
    setScrollY(scrollY);
    requestAnimationFrame(function () {
      setScrollY(scrollY);
    });
  }

  function applyHeaderScrollFreeze(header, snapshot) {
    const rightSide = header.querySelector('.wt-header__right-side');
    const navTeaser = header.querySelector('.wt-header__nav-teaser');
    const headerBody = header.querySelector('.wt-header__body');
    const logoWrapper = header.querySelector('.wt-header__logo-wrapper');
    const logoLink = header.querySelector('.wt-header__logo__link');
    const logoImg = getVisibleLogoImg(header);

    if (snapshot.logoWidth > 0) {
      header.style.setProperty('--am-frozen-logo-width', snapshot.logoWidth + 'px');
      header.style.setProperty('--am-frozen-logo-height', snapshot.logoHeight + 'px');
      header.style.setProperty('--am-frozen-right-side-width', snapshot.rightSideWidth + 'px');
      header.style.setProperty('--am-frozen-body-width', snapshot.bodyWidth + 'px');
    }

    if (snapshot.bodyWidth > 0 && headerBody) {
      headerBody.style.setProperty('width', snapshot.bodyWidth + 'px', 'important');
      headerBody.style.setProperty('max-width', snapshot.bodyWidth + 'px', 'important');
      headerBody.style.setProperty('min-width', snapshot.bodyWidth + 'px', 'important');
      headerBody.style.setProperty('box-sizing', 'border-box', 'important');
    }

    if (snapshot.rightSideWidth > 0 && rightSide) {
      rightSide.style.setProperty('flex', '0 0 auto', 'important');
      rightSide.style.setProperty('width', snapshot.rightSideWidth + 'px', 'important');
      rightSide.style.setProperty('max-width', snapshot.rightSideWidth + 'px', 'important');
      rightSide.style.setProperty('min-width', snapshot.rightSideWidth + 'px', 'important');
      rightSide.style.setProperty('box-sizing', 'border-box', 'important');
    }

    [logoWrapper, logoLink].forEach(function (el) {
      if (!el || snapshot.logoWidth <= 0) return;
      el.style.setProperty('width', snapshot.logoWidth + 'px', 'important');
      el.style.setProperty('max-width', snapshot.logoWidth + 'px', 'important');
      el.style.setProperty('min-width', snapshot.logoWidth + 'px', 'important');
      el.style.setProperty('flex', '0 0 auto', 'important');
      el.style.setProperty('box-sizing', 'border-box', 'important');
    });

    if (logoImg && snapshot.logoWidth > 0) {
      logoImg.style.setProperty('width', snapshot.logoWidth + 'px', 'important');
      logoImg.style.setProperty('max-width', snapshot.logoWidth + 'px', 'important');
      logoImg.style.setProperty('min-width', snapshot.logoWidth + 'px', 'important');
      if (snapshot.logoHeight > 0) {
        logoImg.style.setProperty('height', snapshot.logoHeight + 'px', 'important');
        logoImg.style.setProperty('min-height', snapshot.logoHeight + 'px', 'important');
      }
      logoImg.style.setProperty('flex', '0 0 auto', 'important');
      logoImg.style.setProperty('object-fit', 'contain', 'important');
      logoImg.style.setProperty('box-sizing', 'border-box', 'important');
    }

    if (rightSide && snapshot.rightTransform && snapshot.rightTransform !== 'none') {
      rightSide.style.setProperty('animation', 'none', 'important');
      rightSide.style.setProperty('transform', snapshot.rightTransform, 'important');
    } else if (rightSide) {
      rightSide.style.setProperty('animation', 'none', 'important');
      rightSide.style.setProperty('transform', 'none', 'important');
    }

    // Always show icons when the menu is open — never freeze a scrolled-away teaser.
    if (navTeaser) {
      navTeaser.style.setProperty('animation', 'none', 'important');
      navTeaser.style.setProperty('transform', 'none', 'important');
      navTeaser.style.setProperty('visibility', 'visible', 'important');
      navTeaser.style.setProperty('pointer-events', 'auto', 'important');
    }
  }

  function clearBodyScrollbarPadding() {
    syncBodyScrollbarPadding(null);
  }

  function clearHeaderLayoutFreeze(header) {
    const rightSide = header.querySelector('.wt-header__right-side');
    const navTeaser = header.querySelector('.wt-header__nav-teaser');
    const headerBody = header.querySelector('.wt-header__body');
    const logoWrapper = header.querySelector('.wt-header__logo-wrapper');
    const logoLink = header.querySelector('.wt-header__logo__link');
    const logoImg = getVisibleLogoImg(header);

    header.style.removeProperty('--am-frozen-logo-width');
    header.style.removeProperty('--am-frozen-logo-height');
    header.style.removeProperty('--am-frozen-right-side-width');
    header.style.removeProperty('--am-frozen-body-width');

    if (headerBody) {
      headerBody.style.removeProperty('width');
      headerBody.style.removeProperty('max-width');
      headerBody.style.removeProperty('min-width');
      headerBody.style.removeProperty('box-sizing');
    }

    if (rightSide) {
      rightSide.style.removeProperty('flex');
      rightSide.style.removeProperty('width');
      rightSide.style.removeProperty('max-width');
      rightSide.style.removeProperty('min-width');
      rightSide.style.removeProperty('box-sizing');
    }

    [logoWrapper, logoLink, logoImg].forEach(function (el) {
      if (!el) return;
      el.style.removeProperty('width');
      el.style.removeProperty('max-width');
      el.style.removeProperty('min-width');
      el.style.removeProperty('min-height');
      el.style.removeProperty('height');
      el.style.removeProperty('flex');
      el.style.removeProperty('object-fit');
      el.style.removeProperty('box-sizing');
    });

    // Keep transform/animation when easing the logo down after menu close.
    if (rightSide && !header.classList.contains('am-logo-scroll--menu-release')) {
      rightSide.style.removeProperty('animation');
      rightSide.style.removeProperty('transform');
    }
    if (navTeaser) {
      navTeaser.style.removeProperty('animation');
      navTeaser.style.removeProperty('transform');
      navTeaser.style.removeProperty('visibility');
      navTeaser.style.removeProperty('pointer-events');
    }
  }

  function clearHeaderScrollFreeze(header) {
    clearBodyScrollbarPadding();
    clearHeaderLayoutFreeze(header);
  }

  function clearPendingLogoUnfreezeTimer() {
    if (pendingLogoUnfreezeTimer) {
      clearTimeout(pendingLogoUnfreezeTimer);
      pendingLogoUnfreezeTimer = null;
    }
  }

  function logoStaysCompactAfterMenuClose() {
    if (
      document.body.classList.contains('template-product') &&
      window.matchMedia('(min-width: 900px)').matches
    ) {
      return true;
    }
    if (
      (document.body.classList.contains('am-brands-page') ||
        document.body.classList.contains('template-page-brands')) &&
      window.matchMedia('(min-width: 1200px)').matches
    ) {
      return true;
    }
    return false;
  }

  function clearLogoMenuReleaseStyles(rightSide) {
    if (!rightSide) return;
    rightSide.style.removeProperty('transition');
    rightSide.style.removeProperty('transform');
    rightSide.style.removeProperty('animation');
    rightSide.style.removeProperty('animation-timeline');
  }

  function easeLogoDownAfterMenuClose(header, done) {
    const rightSide = header.querySelector('.wt-header__right-side');
    if (!rightSide || logoStaysCompactAfterMenuClose()) {
      done();
      return;
    }

    refreshMaxOffset();
    const maxPx = cachedMaxOffset || 0;
    if (maxPx <= 0) {
      clearLogoMenuReleaseStyles(rightSide);
      header.classList.remove('am-logo-scroll--menu-release');
      done();
      return;
    }

    var finished = false;
    function finishEase() {
      if (finished) return;
      finished = true;
      rightSide.removeEventListener('transitionend', onEaseEnd);
      clearLogoMenuReleaseStyles(rightSide);
      header.classList.remove('am-logo-scroll--menu-release');
      done();
    }

    function onEaseEnd(e) {
      if (e.target !== rightSide) return;
      if (e.propertyName && e.propertyName !== 'transform') return;
      finishEase();
    }

    header.classList.add('am-logo-scroll--menu-release');
    rightSide.style.setProperty('animation', 'none', 'important');
    rightSide.style.setProperty('animation-timeline', 'auto', 'important');
    rightSide.style.setProperty('transition', 'none', 'important');
    rightSide.style.setProperty(
      'transform',
      'translate3d(0, -' + maxPx + 'px, 0)',
      'important',
    );

    // Force style flush so the next transform change can interpolate.
    void rightSide.offsetHeight;

    rightSide.addEventListener('transitionend', onEaseEnd);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        rightSide.style.setProperty(
          'transition',
          'transform 0.3s cubic-bezier(0, 0, 0.2, 1)',
          'important',
        );
        rightSide.style.setProperty('transform', 'translate3d(0, 0, 0)', 'important');
        setTimeout(finishEase, 350);
      });
    });
  }

  function finishDesktopMenuClose() {
    const header = pendingLayoutUnfreezeHeader;
    if (!header || document.body.classList.contains('menu-open')) return;

    const wasFrozen = header.classList.contains('am-logo-scroll--menu-open-frozen');
    const shouldEaseLogoDown =
      !wasFrozen &&
      header.classList.contains('am-logo-scroll--menu-open') &&
      !logoStaysCompactAfterMenuClose();

    pendingLayoutUnfreezeHeader = null;
    clearPendingLogoUnfreezeTimer();
    hideMenuOverlayImmediate();
    requestAnimationFrame(function () {
      document.body.classList.remove('am-header-menu-closing');
      clearBodyScrollbarPadding();
      requestAnimationFrame(function () {
        // Mark release before freeze clear so pinned transform isn't wiped.
        if (shouldEaseLogoDown) {
          header.classList.add('am-logo-scroll--menu-release');
        }

        header.classList.remove('am-logo-scroll--menu-open-frozen');
        header.classList.remove('am-logo-scroll--menu-open');
        clearHeaderLayoutFreeze(header);
        restoreFrozenScroll();
        frozenMenuScrollY = 0;
        clearMenuOpenFlowCompensation();
        resetMenuOverlayStyles();
        setDesktopMenuScrollLock(false);

        function afterLogoSettle() {
          if (!cssScrollTimeline) {
            updateLogoScrollFallback();
          }
        }

        if (shouldEaseLogoDown) {
          easeLogoDownAfterMenuClose(header, afterLogoSettle);
        } else {
          afterLogoSettle();
        }
      });
    });
  }

  function scheduleDesktopMenuCloseUnfreeze(header) {
    pendingLayoutUnfreezeHeader = header;
    clearPendingLogoUnfreezeTimer();
    pendingLogoUnfreezeTimer = setTimeout(function () {
      finishDesktopMenuClose();
    }, MENU_CLOSE_MS);
  }

  function onMenuOpenChange(isOpen) {
    if (isOpen === menuCurrentlyOpen) return;

    const header = document.querySelector('.wt-header--amateur-custom');
    if (!header) return;

    const isDesktopMenu = window.matchMedia('(min-width: 1200px)').matches;
    const scrollY = getScrollY();
    // Freeze as soon as we've left the top so mid-page opens keep logo size + pin chrome.
    const shouldFreeze = isOpen && isDesktopMenu && scrollY > 0;
    const hadFrozenLayout = header.classList.contains('am-logo-scroll--menu-open-frozen');
    const scrollSnapshot = shouldFreeze
      ? pendingMenuOpenSnapshot || captureHeaderScrollSnapshot(header)
      : null;
    pendingMenuOpenSnapshot = null;

    menuCurrentlyOpen = isOpen;

    const closingDesktopMenu = !isOpen && isDesktopMenu;
    const closingFrozenLayout = closingDesktopMenu && hadFrozenLayout;

    if (isOpen) {
      if (isDesktopMenu) {
        applyDesktopMenuOpenLayoutLock(scrollY);
      }
      setDesktopMenuScrollLock(true, scrollY);
    } else if (!isOpen && !closingDesktopMenu) {
      setDesktopMenuScrollLock(false);
      clearMenuOpenFlowCompensation();
    }

    // Keep compact logo / frozen layout through the drawer close animation.
    if (!closingDesktopMenu) {
      header.classList.toggle('am-logo-scroll--menu-open', isOpen);
      header.classList.toggle('am-logo-scroll--menu-open-frozen', shouldFreeze);
    }

    if (shouldFreeze && scrollSnapshot) {
      pendingLayoutUnfreezeHeader = null;
      clearPendingLogoUnfreezeTimer();
      document.body.classList.remove('am-header-menu-closing');
      if (!frozenMenuScrollY) {
        frozenMenuScrollY = scrollY;
      }
      header.classList.add('am-logo-scroll--menu-open-frozen');
      applyHeaderScrollFreeze(header, scrollSnapshot);
      const sectionHeader = document.querySelector(
        '.shopify-section.page-header, div.page-header.shopify-section',
      );
      if (sectionHeader) {
        sectionHeader.classList.add('sticky-show');
        stickyShowAddedForMenuOpen = true;
      }
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (!header.classList.contains('am-logo-scroll--menu-open-frozen')) return;
          applyHeaderScrollFreeze(header, scrollSnapshot);
        });
      });
    } else if (closingDesktopMenu) {
      document.body.classList.add('am-header-menu-closing');
      clearMenuOpenFlowCompensation();
      if (closingFrozenLayout) {
        restoreFrozenScroll();
        requestAnimationFrame(restoreFrozenScroll);
      }
      scheduleDesktopMenuCloseUnfreeze(header);
    } else {
      pendingLayoutUnfreezeHeader = null;
      clearPendingLogoUnfreezeTimer();
      document.body.classList.remove('am-header-menu-closing');
      if (isOpen && isDesktopMenu) {
        const sectionHeader = document.querySelector(
          '.shopify-section.page-header, div.page-header.shopify-section',
        );
        if (sectionHeader) {
          sectionHeader.classList.add('sticky-show');
          stickyShowAddedForMenuOpen = true;
        }
      } else {
        clearHeaderScrollFreeze(header);
        if (isOpen) {
          stickyShowAddedForMenuOpen = false;
        }
      }
    }

    setLogoScrollMode();

    if (!isOpen) {
      stickyShowAddedForMenuOpen = false;
      if (!cssScrollTimeline && !closingDesktopMenu) {
        updateLogoScrollFallback();
      }
    }

    if (cssScrollTimeline) return;

    if (isOpen) {
      if (isDesktopMenu && shouldFreeze) {
        const progress = getLogoScrollProgress();
        header.style.setProperty('--logo-scroll-offset', '-' + cachedMaxOffset * progress + 'px');
        if (shouldScrollNavTeaserAway()) {
          header.style.setProperty(
            '--nav-teaser-scroll-offset',
            '-' + cachedNavTeaserMaxOffset * progress + 'px',
          );
        } else {
          header.style.removeProperty('--nav-teaser-scroll-offset');
        }
      } else if (isDesktopMenu) {
        header.style.setProperty('--logo-scroll-offset', '-' + cachedMaxOffset + 'px');
        header.style.removeProperty('--nav-teaser-scroll-offset');
      } else {
        header.style.setProperty('--logo-scroll-offset', '-' + cachedMaxOffset + 'px');
        header.style.removeProperty('--nav-teaser-scroll-offset');
      }
    } else if (closingDesktopMenu && !closingFrozenLayout) {
      // Hold compact offset for the close animation (JS scroll fallback).
      header.style.setProperty('--logo-scroll-offset', '-' + cachedMaxOffset + 'px');
    }
  }

  function initMegaParentNavNoFollow() {
    const mega = document.querySelector(
      'mega-menu-section[data-am-disable-parent-nav-desktop]',
    );
    if (!mega) return;

    function bindLinks() {
      mega.querySelectorAll('a.wt-page-nav-mega__link--parent').forEach(function (a) {
        if (a.dataset.amParentNavBound === '1') return;
        a.dataset.amParentNavBound = '1';

        a.addEventListener(
          'click',
          function (e) {
            if (isDesktopMegaNav()) {
              e.preventDefault();
              e.stopPropagation();
              return;
            }
            e.preventDefault();
          },
          true,
        );

        a.addEventListener(
          'auxclick',
          function (e) {
            if (e.button !== 1) return;
            e.preventDefault();
            e.stopPropagation();
          },
          true,
        );
      });
    }

    bindLinks();
    new MutationObserver(bindLinks).observe(mega, { childList: true, subtree: true });
  }

  function initCollectionBarStickyTop() {
    if (!document.body.classList.contains('template-collection')) return;
    if (!document.querySelector('.am-collection-bar')) return;

    var stickyMq = window.matchMedia('(max-width: 899px)');
    var ticking = false;

    function updateStickyTop() {
      ticking = false;
      if (!stickyMq.matches) {
        document.documentElement.style.removeProperty('--collection-bar-sticky-top');
        document.documentElement.classList.remove('am-collection-header-clipped');
        return;
      }

      var header = document.querySelector('#header.wt-header--amateur-custom');
      if (!header) return;

      /* Stick flush under the icon row. */
      var teaser = header.querySelector('.wt-header__nav-teaser');
      var bottom = teaser
        ? teaser.getBoundingClientRect().bottom
        : (
            header.querySelector('.wt-header__body') ||
            document.querySelector('.shopify-section:has(page-header)') ||
            document.querySelector('header.page-header') ||
            header
          ).getBoundingClientRect().bottom;

      var top = Math.max(0, Math.round(bottom));
      document.documentElement.style.setProperty('--collection-bar-sticky-top', top + 'px');

      /*
       * After any scroll, clip the sticky header to the teaser band so the bar is not
       * hidden behind the tall opaque logo area (keeps header above the product grid).
       */
      var scrolled = (window.scrollY || document.documentElement.scrollTop || 0) > 0;
      document.documentElement.classList.toggle('am-collection-header-clipped', scrolled);
    }

    function onScrollOrResize() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(updateStickyTop);
    }

    updateStickyTop();
    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize, { passive: true });
    stickyMq.addEventListener('change', updateStickyTop);
    window.addEventListener('am-header-logo-layout', updateStickyTop);
  }

  function init() {
    const header = document.querySelector('.wt-header--amateur-custom');
    if (!header) return;

    setLogoScrollMode();
    initCollectionBarStickyTop();

    window.addEventListener('scroll', onScrollFallback, { passive: true });
    window.addEventListener('scroll', onDesktopMenuScrollLock, { passive: true });
    document.addEventListener('wheel', onDesktopMenuWheelLock, { passive: false, capture: true });
    document.addEventListener('touchmove', onDesktopMenuTouchMoveLock, { passive: false, capture: true });
    document.addEventListener('keydown', onDesktopMenuKeydownLock, { capture: true });

    window.addEventListener('resize', setLogoScrollMode);
    window.addEventListener('am-header-logo-layout', setLogoScrollMode);
    window.addEventListener('am-collection-header-suppress-until-top', function () {
      /* Collection mobile header stays sticky; ignore suppress requests. */
    });

    /* Android DPR race: innerWidth can start ~2× visualViewport; remeasure when layout settles. */
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', setLogoScrollMode);
    }
    (function settleLogoLayout() {
      var tries = 0;
      var lastW = 0;
      function tick() {
        tries += 1;
        var w = window.innerWidth;
        var vv = window.visualViewport;
        var visualW = vv && vv.width > 0 ? Math.round(vv.width) : w;
        if (w !== lastW) {
          lastW = w;
          setLogoScrollMode();
        }
        if (tries < 20 && (w > visualW * 1.1 || tries < 8)) {
          requestAnimationFrame(tick);
        }
      }
      requestAnimationFrame(tick);
    })();

    setTimeout(setLogoScrollMode, 300);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(setLogoScrollMode);
    }

    initMegaParentNavNoFollow();
    initBreakpointTransitionSuppressor();
    initMenuOpenSnapshotPrime();
    initDrawerCloseHandler();

    var lastFooterRevealOnBody = document.body.classList.contains('am-header-footer-reveal');

    new MutationObserver(function () {
      onMenuOpenChange(document.body.classList.contains('menu-open'));
      var footerRevealOnBody = document.body.classList.contains('am-header-footer-reveal');
      if (footerRevealOnBody !== lastFooterRevealOnBody) {
        lastFooterRevealOnBody = footerRevealOnBody;
        onFooterRevealChange(footerRevealOnBody);
      }
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });

    onFooterRevealChange(document.body.classList.contains('am-header-footer-reveal'));
    applyCollectionHeaderSuppressionState();
  }

  function initDrawerCloseHandler() {
    const drawer = document.querySelector('#wt-drawer-nav');
    if (!drawer || drawer.dataset.amDrawerCloseHandler === '1') return;
    drawer.dataset.amDrawerCloseHandler = '1';
    drawer.addEventListener('transitionend', function (e) {
      if (e.propertyName !== 'transform') return;
      if (!pendingLayoutUnfreezeHeader) return;
      if (document.body.classList.contains('menu-open')) return;
      finishDesktopMenuClose();
    });
  }

  function initMenuOpenSnapshotPrime() {
    document.addEventListener(
      'pointerdown',
      function (e) {
        if (document.body.classList.contains('menu-open')) return;
        const trigger = e.target.closest(
          '[rel="toggle-menu"], .wt-header__menu-trigger, .wt-header__nav-teaser__link--parent',
        );
        if (!trigger || !document.querySelector('.wt-header--amateur-custom')) return;
        primeMenuOpenSnapshot();
      },
      true,
    );
  }

  function initBreakpointTransitionSuppressor() {
    var mq = window.matchMedia('(min-width: 1200px)');

    function suppress() {
      var drawer = document.querySelector('.wt-header--amateur-custom ~ .wt-drawer--nav');
      var rightSide = document.querySelector(
        '.wt-header--amateur-custom .wt-header__right-side',
      );
      var filter = document.querySelector('.wt-filter');

      if (drawer) {
        drawer.style.setProperty('transition', 'none', 'important');
        drawer.style.setProperty('opacity', '0', 'important');
        drawer.style.removeProperty('--top-margin');
      }
      if (rightSide) {
        rightSide.style.setProperty('transition', 'none', 'important');
      }
      if (filter) {
        filter.style.setProperty('transition', 'none', 'important');
        filter.style.setProperty('opacity', '0', 'important');
      }

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (drawer) drawer.getBoundingClientRect();

          setTimeout(function () {
            if (drawer) {
              drawer.style.removeProperty('transition');
              drawer.style.removeProperty('opacity');
            }
            if (rightSide) rightSide.style.removeProperty('transition');
            if (filter) {
              filter.style.removeProperty('transition');
              filter.style.removeProperty('opacity');
            }
            setLogoScrollMode();
          }, 100);
        });
      });
    }

    mq.addEventListener('change', suppress);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

(function () {
  var mainFillHeightSet = false;

  function setHeaderHeight() {
    var header = document.querySelector('page-header');
    if (!header) return;
    var height = header.getBoundingClientRect().height;
    if (height > 0) {
      document.documentElement.style.setProperty('--header-height', height + 'px');
    }
  }

  /** Prefer the smaller of innerHeight / visualViewport to avoid Android URL-bar + DPR races. */
  function getLayoutViewportHeight() {
    var h = window.innerHeight || 0;
    if (window.visualViewport && window.visualViewport.height > 0) {
      h = Math.min(h, Math.round(window.visualViewport.height));
    }
    return h;
  }

  /**
   * Set --main-fill-height once, but allow a one-time correction if an early
   * measurement was inflated (common: DPR/window race → ~2× viewport).
   */
  function setMainFillHeightOnce() {
    var main = document.getElementById('root');
    if (!main) return;
    var top = main.offsetTop;
    var vh = getLayoutViewportHeight();
    var fill = Math.max(0, Math.round(vh - top));
    if (fill <= 0) return;

    var existing = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue('--main-fill-height'),
    );
    if (mainFillHeightSet && !isNaN(existing) && existing > vh * 1.15) {
      mainFillHeightSet = false;
    }
    if (mainFillHeightSet) return;

    document.documentElement.style.setProperty('--main-fill-height', fill + 'px');
    mainFillHeightSet = true;
  }

  function initLayoutHeights() {
    setHeaderHeight();
    setMainFillHeightOnce();
  }

  initLayoutHeights();
  window.addEventListener('resize', setHeaderHeight);
  window.addEventListener('load', initLayoutHeights);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLayoutHeights);
  }

  if (typeof ResizeObserver !== 'undefined') {
    var header = document.querySelector('page-header');
    if (header) {
      new ResizeObserver(setHeaderHeight).observe(header);
    }

    var headerSection = document.querySelector('.shopify-section:has(page-header)');
    if (headerSection) {
      new ResizeObserver(setHeaderHeight).observe(headerSection);
    }
  }
})();
